var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content bg-light"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Register'
    }
  })], 1)], 1), _c('section', {
    staticClass: "login-form section bg-light p-0 my-5"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5 px-lg-5"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_vm._m(0), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "mt-1 w-100"
  }, [_c('form-wizard', {
    ref: "wizard",
    staticClass: "width-override form-floating",
    attrs: {
      "errorMessage": _vm.signUpError
    },
    on: {
      "onComplete": _vm.onComplete,
      "onNextStep": _vm.nextStep,
      "onPreviousStep": _vm.previousStep
    }
  }, [_vm.currentStep > 0 ? [_c('button', {
    on: {
      "click": _vm.goToPreviousStep
    }
  }, [_vm._v("Previous")])] : _vm._e(), _c('tab-content', {
    attrs: {
      "title": "Account Info",
      "selected": true
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-label-group"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.firstName,
      expression: "formData.firstName"
    }],
    staticClass: "form-control",
    class: _vm.hasError('firstName') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "id": "firstName",
      "placeholder": "First Name"
    },
    domProps: {
      "value": _vm.formData.firstName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "firstName", $event.target.value);
      }
    }
  }), _vm.hasError('firstName') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.firstName.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide your first name ")]) : _vm._e()]) : _vm._e()])]), _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.lastName,
      expression: "formData.lastName"
    }],
    staticClass: "form-control",
    class: _vm.hasError('lastName') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": _vm.formData.lastName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "lastName", $event.target.value);
      }
    }
  }), _vm.hasError('lastName') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.lastName.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide your last name ")]) : _vm._e()]) : _vm._e()])]), _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Your Email*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.email,
      expression: "formData.email"
    }],
    staticClass: "form-control",
    class: _vm.hasError('email') ? 'is-invalid' : '',
    attrs: {
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": _vm.formData.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "email", $event.target.value);
      }
    }
  }), _vm.hasError('email') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.email.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Email address is required ")]) : _vm._e(), !_vm.$v.formData.email.email ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Should be in email format ")]) : _vm._e()]) : _vm._e()])]), _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "forumScreenName"
    }
  }, [_vm._v("Forum Username*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.forumScreenName,
      expression: "formData.forumScreenName"
    }],
    staticClass: "form-control",
    class: _vm.hasError('forumScreenName') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": _vm.formData.forumScreenName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "forumScreenName", $event.target.value);
      }, _vm.onChangeForumUsername]
    }
  }), _vm.hasError('forumScreenName') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.forumScreenName.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide a screen name ")]) : _vm._e()]) : _vm._e()])]), _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password*")]), _vm.passwordFieldType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.password,
      expression: "formData.password"
    }],
    staticClass: "form-control",
    class: _vm.hasError('password') ? 'is-invalid' : '',
    attrs: {
      "placeholder": "Password",
      "autocomplete": "password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.password) ? _vm._i(_vm.formData.password, null) > -1 : _vm.formData.password
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.formData.password,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.formData, "password", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.formData, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.formData, "password", $$c);
        }
      }
    }
  }) : _vm.passwordFieldType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.password,
      expression: "formData.password"
    }],
    staticClass: "form-control",
    class: _vm.hasError('password') ? 'is-invalid' : '',
    attrs: {
      "placeholder": "Password",
      "autocomplete": "password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formData.password, null)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.formData, "password", null);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.password,
      expression: "formData.password"
    }],
    staticClass: "form-control",
    class: _vm.hasError('password') ? 'is-invalid' : '',
    attrs: {
      "placeholder": "Password",
      "autocomplete": "password",
      "type": _vm.passwordFieldType
    },
    domProps: {
      "value": _vm.formData.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "password", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "password-icon",
    on: {
      "click": _vm.togglePasswordVisibility
    }
  }, [_vm.passwordFieldType === 'password' ? _c('i', {
    staticClass: "fa fa-eye custom-color"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash custom-color"
  })]), _vm.hasError('password') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.password.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Password is required ")]) : _vm._e(), !_vm.$v.formData.password.goodPassword ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Must be at least 8 characters and contain a lowercase, uppercase, number and special character. ")]) : _vm._e()]) : _vm._e(), !_vm.hasError('password') ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" Must be at least 8 characters and contain a lowercase, uppercase, number and special character. ")]) : _vm._e()])]), _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "confirmPassword"
    }
  }, [_vm._v("Confirm Password*")]), _vm.passwordFieldTypeC === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.confirmPassword,
      expression: "formData.confirmPassword"
    }],
    staticClass: "form-control",
    class: _vm.hasError('confirmPassword') ? 'is-invalid' : '',
    attrs: {
      "placeholder": "Confirm Password",
      "autocomplete": "password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.confirmPassword) ? _vm._i(_vm.formData.confirmPassword, null) > -1 : _vm.formData.confirmPassword
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.formData.confirmPassword,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.formData, "confirmPassword", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.formData, "confirmPassword", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.formData, "confirmPassword", $$c);
        }
      }
    }
  }) : _vm.passwordFieldTypeC === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.confirmPassword,
      expression: "formData.confirmPassword"
    }],
    staticClass: "form-control",
    class: _vm.hasError('confirmPassword') ? 'is-invalid' : '',
    attrs: {
      "placeholder": "Confirm Password",
      "autocomplete": "password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.formData.confirmPassword, null)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.formData, "confirmPassword", null);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.confirmPassword,
      expression: "formData.confirmPassword"
    }],
    staticClass: "form-control",
    class: _vm.hasError('confirmPassword') ? 'is-invalid' : '',
    attrs: {
      "placeholder": "Confirm Password",
      "autocomplete": "password",
      "type": _vm.passwordFieldTypeC
    },
    domProps: {
      "value": _vm.formData.confirmPassword
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "confirmPassword", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "password-iconC",
    on: {
      "click": _vm.togglePasswordVisibilityC
    }
  }, [_vm.passwordFieldTypeC === 'password' ? _c('i', {
    staticClass: "fas fa-eye custom-color"
  }) : _c('i', {
    staticClass: "fas fa-eye-slash custom-color"
  })]), _vm.hasError('confirmPassword') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.confirmPassword.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please confirm your password ")]) : _vm._e(), _vm.$v.formData.confirmPassword.required && !_vm.$v.formData.confirmPassword.sameAs ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please re-enter the password given above ")]) : _vm._e()]) : _vm._e()])]), _c('div', {
    staticClass: "col-12 col-md-7 col-lg-7 col-xl-7",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('LlaAgreementWidget', {
    attrs: {
      "username": _vm.formData.forumScreenName,
      "llaStatus": _vm.formData.iagreeStatus,
      "llaAgreementStatusHandler": _vm.onLLAgreementSelectionHandler
    }
  })], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Account Type"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v("Choose your account type (select each to view more information):")]), _c('b-form-radio-group', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.accountTypes,
      "value-field": "item",
      "text-field": "name",
      "stacked": ""
    },
    model: {
      value: _vm.formData.accountType,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "accountType", $$v);
      },
      expression: "formData.accountType"
    }
  })], 1), _vm.formData.accountType === _vm.AccountTypes.INDIVIDUAL ? _c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("INDIVIDUAL")]), _c('h2', [_vm._v("Individual Account")])]), _c('div', {
    staticClass: "mt-4 text-lg-left"
  }, [_c('p', [_vm._v(" If you choose to open your account by registering as an individual (unaffiliated with a specific company), you gain immediate access to many of Project Spectrum’s key offerings including: ")]), _c('ul', [_c('li', [_vm._v("Cyber Security Training (for individuals)")]), _c('li', [_vm._v("Informational Webinars")]), _c('li', [_vm._v(" Cyber Circuits Sessions (Hear DIRECTLY from community leaders and tech experts!) ")]), _c('li', [_vm._v("White Papers")]), _c('li', [_vm._v("Blogs")])])])]) : _vm._e(), _vm.formData.accountType === _vm.AccountTypes.ORG_ADMIN ? _c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("ORGANIZATION ")]), _c('h2', [_vm._v("Organization Account")])]), _c('div', {
    staticClass: "mt-4 text-lg-left"
  }, [_c('p', [_vm._v(" As an organization, you can register today to start your compliance journey! We provide tailored resources to help you based on your current level of cyber hygiene. Your organization can immediately access our Cyber Readiness Check utility to help you determine how compliant you are with NIST and CMMC cybersecurity standards. You will also get direct access to our expert cyber advisors – and one will be assigned as your personal guide on your cybersecurity compliance journey. If you are the first member of your organization to join Project Spectrum, you will be made the administrator of the organization. As your company’s administrator, you can invite specific members of your organization to join Project Spectrum and recommend specific material to them that they might otherwise miss. In addition to those benefits, as a registered organization you will have access to a myriad of resources to boost your cybersecurity posture, including: ")]), _c('ul', [_c('li', [_vm._v("Cyber Readiness Checks (for organization)")]), _c('li', [_vm._v(" Cyber Security Training (for all members of organization) ")]), _c('li', [_vm._v(" Virtual Labs (for all members of organization) ")]), _c('li', [_vm._v("Informational Webinars")]), _c('li', [_vm._v(" Cyber Circuits Sessions (Hear DIRECTLY from community leaders and tech experts!) ")]), _c('li', [_vm._v("White Papers")]), _c('li', [_vm._v("Blogs")]), _c('li', [_vm._v("Cybersecurity Tool Reviews")])])])]) : _vm._e(), _vm.formData.accountType === _vm.AccountTypes.ORG_MEMBER ? _c('div', {
    staticClass: "col-12 py-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('span', [_vm._v("ORGANIZATION MEMBER")]), _c('h2', [_vm._v("Organization Member Account (Affiliate)")])]), _c('div', {
    staticClass: "mt-4 text-lg-left"
  }, [_c('p', [_vm._v(" If your company is already a member of Project Spectrum and you want to open an individual account to access our key cybersecurity resources, simply register as an individual and identify your company during the registration process. By joining, you gain immediate access to a trove of important resources to improve your level of cybersecurity expertise and to help your organization raise its overall level of cyber hygiene. By choosing to join others in your company and opening an account today, you gain immediate access to Project Spectrum’s key offerings including: ")]), _c('ul', [_c('li', [_vm._v("Cyber Readiness Checks (for organization)")]), _c('li', [_vm._v("Cyber Security Training (for individuals)")]), _c('li', [_vm._v("Virtual Labs (for individuals)")]), _c('li', [_vm._v("Informational Webinars")]), _c('li', [_vm._v(" Cyber Circuits Sessions (Hear DIRECTLY from community leaders and tech experts!) ")]), _c('li', [_vm._v("White Papers")]), _c('li', [_vm._v("Blogs")]), _c('li', [_vm._v("Cybersecurity Tool Reviews")])])])]) : _vm._e(), _c('div', {
    staticClass: "col-12 col-md-7 col-lg-7 col-xl-7",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('LlaAgreementWidget', {
    attrs: {
      "username": _vm.formData.forumScreenName,
      "llaStatus": _vm.formData.iagreeStatus,
      "llaAgreementStatusHandler": _vm.onLLAgreementSelectionHandler
    }
  })], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": _vm.formData.accountType === _vm.AccountTypes.INDIVIDUAL ? 'Contact Info' : 'Company Info'
    }
  }, [_vm.isOrgAdmin ? _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "py-2"
  }, [_c('b-form-group', {
    staticClass: "font-italic",
    attrs: {
      "label": "Do you want to enter your company's CAGE code or DUNS number and look up some of the required fields?"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": true
    },
    model: {
      value: _vm.formData.useCompanyCodeLookup,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "useCompanyCodeLookup", $$v);
      },
      expression: "formData.useCompanyCodeLookup"
    }
  }, [_vm._v("Yes")]), _c('b-form-radio', {
    attrs: {
      "value": false
    },
    model: {
      value: _vm.formData.useCompanyCodeLookup,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "useCompanyCodeLookup", $$v);
      },
      expression: "formData.useCompanyCodeLookup"
    }
  }, [_vm._v("No")])], 1)], 1)]), _vm.formData.useCompanyCodeLookup ? _c('b-col', {
    staticClass: "mb-4 p-4 border border-secondary rounded",
    attrs: {
      "sm": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "companyCodeLookup"
    }
  }, [_vm._v("Company's CAGE code or DUNS number *")]), _c('b-row', [_c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-label-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.companyCodeLookup,
      expression: "formData.companyCodeLookup"
    }],
    staticClass: "form-control",
    class: _vm.hasError('companyCodeLookup') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "id": "companyCodeLookup"
    },
    domProps: {
      "value": _vm.formData.companyCodeLookup
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "companyCodeLookup", $event.target.value);
      }
    }
  }), _vm.hasError('companyCodeLookup') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.companyCodeLookup.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide your company's CAGE code or DUNS number. ")]) : _vm._e()]) : _vm._e(), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" 5 character alpha-numeric CAGE code, or 9 character numeric DUNS number ")])])]), _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "btn w-100 rounded centered-link theme-btn-secondary"
    },
    on: {
      "click": _vm.onLookupCageCodeOrDuns
    }
  }, [_vm._v("Lookup Code")]), _vm.companyLookupSuccessMessage ? _c('b-alert', {
    staticClass: "p-2 px-3 my-1",
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.companyLookupSuccessMessage))]) : _vm._e(), _vm.companyLookupErrorMessage ? _c('b-alert', {
    staticClass: "p-2 px-3 my-1",
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.companyLookupErrorMessage))]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _c('b-row', [_vm.isOrgAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organization"
    }
  }, [_vm._v(" Organization* ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.organization,
      expression: "formData.organization"
    }],
    staticClass: "form-control",
    class: _vm.hasError('organization') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Organization"
    },
    domProps: {
      "value": _vm.formData.organization
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "organization", $event.target.value);
      }
    }
  }), _vm.hasError('organization') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.organization.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Enter the name of your organization ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organizationRole"
    }
  }, [_vm._v("Role in Organization")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.organizationRole,
      expression: "formData.organizationRole"
    }],
    staticClass: "form-control",
    class: _vm.hasError('organizationRole') ? 'is-invalid' : '',
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.formData, "organizationRole", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(" Select Organization Role ")]), _c('option', {
    attrs: {
      "value": "Executive or leadership"
    }
  }, [_vm._v(" Executive or leadership ")]), _c('option', {
    attrs: {
      "value": "Chief Information Officer (CIO) or Chief Information Security Officer (CISO)"
    }
  }, [_vm._v(" Chief Information Officer (CIO) or Chief Information Security Officer (CISO) ")]), _c('option', {
    attrs: {
      "value": "Operations Manager"
    }
  }, [_vm._v(" Operations Manager ")]), _c('option', {
    attrs: {
      "value": "Technical program manager"
    }
  }, [_vm._v(" Technical program manager ")]), _c('option', {
    attrs: {
      "value": "Sales"
    }
  }, [_vm._v("Sales")]), _c('option', {
    attrs: {
      "value": "Manufacturing"
    }
  }, [_vm._v("Manufacturing")]), _c('option', {
    attrs: {
      "value": "Research or engineering"
    }
  }, [_vm._v(" Research or engineering ")]), _c('option', {
    attrs: {
      "value": "Marketing or communications"
    }
  }, [_vm._v(" Marketing or communications ")]), _c('option', {
    attrs: {
      "value": "Financial"
    }
  }, [_vm._v("Financial")]), _c('option', {
    attrs: {
      "value": "Human resources"
    }
  }, [_vm._v(" Human resources ")]), _c('option', {
    attrs: {
      "value": "Analyst"
    }
  }, [_vm._v("Analyst")]), _c('option', {
    attrs: {
      "value": "IT support"
    }
  }, [_vm._v("IT support")]), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address1"
    }
  }, [_vm._v("Street Address 1*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.address1,
      expression: "formData.address1"
    }],
    staticClass: "form-control",
    class: _vm.hasError('address1') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": _vm.formData.address1
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "address1", $event.target.value);
      }
    }
  }), !_vm.hasError('address1') ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" Street address, P.O. box, company name ")]) : _vm._e(), _vm.hasError('address1') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.address1.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide organization street address ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address2"
    }
  }, [_vm._v("Street Address 2")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.address2,
      expression: "formData.address2"
    }],
    staticClass: "form-control",
    class: _vm.hasError('address2') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Address Continued..."
    },
    domProps: {
      "value": _vm.formData.address2
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "address2", $event.target.value);
      }
    }
  }), !_vm.hasError('address2') ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" Apartment, suite, unit, building, floor, etc. ")]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.city,
      expression: "formData.city"
    }],
    staticClass: "form-control",
    class: _vm.hasError('city') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": _vm.formData.city
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "city", $event.target.value);
      }
    }
  }), _vm.hasError('city') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.city.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide organization city ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State or Territory*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.state,
      expression: "formData.state"
    }],
    staticClass: "form-control",
    class: _vm.hasError('state') ? 'is-invalid' : '',
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.formData, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select State or Territory")]), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("Alabama")]), _c('option', {
    attrs: {
      "value": "AK"
    }
  }, [_vm._v("Alaska")]), _c('option', {
    attrs: {
      "value": "AS"
    }
  }, [_vm._v("American Samoa")]), _c('option', {
    attrs: {
      "value": "AZ"
    }
  }, [_vm._v("Arizona")]), _c('option', {
    attrs: {
      "value": "AR"
    }
  }, [_vm._v("Arkansas")]), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("California")]), _c('option', {
    attrs: {
      "value": "CO"
    }
  }, [_vm._v("Colorado")]), _c('option', {
    attrs: {
      "value": "CT"
    }
  }, [_vm._v("Connecticut")]), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Delaware")]), _c('option', {
    attrs: {
      "value": "DC"
    }
  }, [_vm._v("District Of Columbia")]), _c('option', {
    attrs: {
      "value": "FL"
    }
  }, [_vm._v("Florida")]), _c('option', {
    attrs: {
      "value": "GA"
    }
  }, [_vm._v("Georgia")]), _c('option', {
    attrs: {
      "value": "GU"
    }
  }, [_vm._v("Guam")]), _c('option', {
    attrs: {
      "value": "HI"
    }
  }, [_vm._v("Hawaii")]), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Idaho")]), _c('option', {
    attrs: {
      "value": "IL"
    }
  }, [_vm._v("Illinois")]), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("Indiana")]), _c('option', {
    attrs: {
      "value": "IA"
    }
  }, [_vm._v("Iowa")]), _c('option', {
    attrs: {
      "value": "KS"
    }
  }, [_vm._v("Kansas")]), _c('option', {
    attrs: {
      "value": "KY"
    }
  }, [_vm._v("Kentucky")]), _c('option', {
    attrs: {
      "value": "LA"
    }
  }, [_vm._v("Louisiana")]), _c('option', {
    attrs: {
      "value": "ME"
    }
  }, [_vm._v("Maine")]), _c('option', {
    attrs: {
      "value": "MD"
    }
  }, [_vm._v("Maryland")]), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("Massachusetts")]), _c('option', {
    attrs: {
      "value": "MI"
    }
  }, [_vm._v("Michigan")]), _c('option', {
    attrs: {
      "value": "MN"
    }
  }, [_vm._v("Minnesota")]), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("Mississippi")]), _c('option', {
    attrs: {
      "value": "MO"
    }
  }, [_vm._v("Missouri")]), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("Montana")]), _c('option', {
    attrs: {
      "value": "NE"
    }
  }, [_vm._v("Nebraska")]), _c('option', {
    attrs: {
      "value": "NV"
    }
  }, [_vm._v("Nevada")]), _c('option', {
    attrs: {
      "value": "NH"
    }
  }, [_vm._v("New Hampshire")]), _c('option', {
    attrs: {
      "value": "NJ"
    }
  }, [_vm._v("New Jersey")]), _c('option', {
    attrs: {
      "value": "NM"
    }
  }, [_vm._v("New Mexico")]), _c('option', {
    attrs: {
      "value": "NY"
    }
  }, [_vm._v("New York")]), _c('option', {
    attrs: {
      "value": "NC"
    }
  }, [_vm._v("North Carolina")]), _c('option', {
    attrs: {
      "value": "ND"
    }
  }, [_vm._v("North Dakota")]), _c('option', {
    attrs: {
      "value": "MP"
    }
  }, [_vm._v("Northern Mariana Islands")]), _c('option', {
    attrs: {
      "value": "OH"
    }
  }, [_vm._v("Ohio")]), _c('option', {
    attrs: {
      "value": "OK"
    }
  }, [_vm._v("Oklahoma")]), _c('option', {
    attrs: {
      "value": "OR"
    }
  }, [_vm._v("Oregon")]), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("Pennsylvania")]), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("Puerto Rico")]), _c('option', {
    attrs: {
      "value": "RI"
    }
  }, [_vm._v("Rhode Island")]), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("South Carolina")]), _c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("South Dakota")]), _c('option', {
    attrs: {
      "value": "TN"
    }
  }, [_vm._v("Tennessee")]), _c('option', {
    attrs: {
      "value": "TX"
    }
  }, [_vm._v("Texas")]), _c('option', {
    attrs: {
      "value": "UM"
    }
  }, [_vm._v(" United States Minor Outlying Islands ")]), _c('option', {
    attrs: {
      "value": "UT"
    }
  }, [_vm._v("Utah")]), _c('option', {
    attrs: {
      "value": "VT"
    }
  }, [_vm._v("Vermont")]), _c('option', {
    attrs: {
      "value": "VI"
    }
  }, [_vm._v("Virgin Islands")]), _c('option', {
    attrs: {
      "value": "VA"
    }
  }, [_vm._v("Virginia")]), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("Washington")]), _c('option', {
    attrs: {
      "value": "WV"
    }
  }, [_vm._v("West Virginia")]), _c('option', {
    attrs: {
      "value": "WI"
    }
  }, [_vm._v("Wisconsin")]), _c('option', {
    attrs: {
      "value": "WY"
    }
  }, [_vm._v("Wyoming")])]), _vm.hasError('state') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.state.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide organization state ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "zipCode"
    }
  }, [_vm._v("Zip Code*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.zipCode,
      expression: "formData.zipCode"
    }],
    staticClass: "form-control",
    class: _vm.hasError('zipCode') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "placeholder": "Zip Code"
    },
    domProps: {
      "value": _vm.formData.zipCode
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "zipCode", $event.target.value);
      }
    }
  }), _vm.hasError('zipCode') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.zipCode.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide your organization zip code ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.country,
      expression: "formData.country"
    }],
    staticClass: "form-control",
    class: _vm.hasError('country') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Country"
    },
    domProps: {
      "value": _vm.formData.country
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "country", $event.target.value);
      }
    }
  }), _vm.hasError('country') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.country.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide your organization country ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "telephone"
    }
  }, [_vm._v("Phone")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.telephone,
      expression: "formData.telephone"
    }],
    staticClass: "form-control",
    class: _vm.hasError('telephone') ? 'is-invalid' : '',
    attrs: {
      "type": "tel",
      "pattern": "[0-9]{3}-[0-9]{3}-[0-9]{4}",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": _vm.formData.telephone
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "telephone", $event.target.value);
      }
    }
  }), _vm.hasError('telephone') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.telephone.goodPhone ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide a 10-digit U.S. phone number ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isIndividualOrAdminOrMember ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-column mb-3"
  }, [_c('label', {
    attrs: {
      "for": "referringOrganization"
    }
  }, [_vm._v("Referring Organization*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.referringOrganization,
      expression: "formData.referringOrganization"
    }],
    staticClass: "form-control",
    class: _vm.hasError('referringOrganization') ? 'is-invalid' : '',
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.formData, "referringOrganization", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "MPP"
    }
  }, [_vm._v("MPP")]), _c('option', {
    attrs: {
      "value": "MEP"
    }
  }, [_vm._v("MEP")]), _c('option', {
    attrs: {
      "value": "APEX"
    }
  }, [_vm._v("APEX")]), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")])]), _vm.hasError('referringOrganization') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.referringOrganization.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide referring organization ")]) : _vm._e()]) : _vm._e()]), _vm.formData.referringOrganization === 'OTHER' ? _c('div', {
    staticClass: "w-100 d-flex flex-column"
  }, [_c('label', {
    attrs: {
      "for": "other"
    }
  }, [_vm._v("Other Organization*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.otherOrganization,
      expression: "formData.otherOrganization"
    }],
    staticClass: "form-control",
    class: _vm.hasError('otherOrganization') ? 'is-invalid' : '',
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.formData.otherOrganization
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "otherOrganization", $event.target.value);
      }
    }
  }), _vm.hasError('otherOrganization') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.otherOrganization.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide other organization ")]) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.website,
      expression: "formData.website"
    }],
    staticClass: "form-control",
    class: _vm.hasError('website') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": _vm.formData.website
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "website", $event.target.value);
      }
    }
  })])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organizationType"
    }
  }, [_vm._v("Organization Type*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.organizationType,
      expression: "formData.organizationType"
    }],
    staticClass: "form-control h-auto",
    class: _vm.hasError('organizationType') ? 'is-invalid' : '',
    staticStyle: {
      "min-height": "290px"
    },
    attrs: {
      "multiple": "",
      "id": "organizationType"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.formData, "organizationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SB"
    }
  }, [_vm._v("Small Business (SB)")]), _c('option', {
    attrs: {
      "value": "SDB"
    }
  }, [_vm._v(" Small Disadvantaged Business (SDB) ")]), _c('option', {
    attrs: {
      "value": "8(a)"
    }
  }, [_vm._v("8(a) Business")]), _c('option', {
    attrs: {
      "value": "WOSB"
    }
  }, [_vm._v(" Women Owned Small Business (WOSB) ")]), _c('option', {
    attrs: {
      "value": "VOSB"
    }
  }, [_vm._v(" Veteran Owned Small Business (VOSB) ")]), _c('option', {
    attrs: {
      "value": "SDVOSB"
    }
  }, [_vm._v(" Service Disabled Veteran Owned Small Business (SDVOSB) ")]), _c('option', {
    attrs: {
      "value": "HUBZone"
    }
  }, [_vm._v("HUBZone Business")]), _c('option', {
    attrs: {
      "value": "EDWOSB"
    }
  }, [_vm._v(" Economically Disadvantaged Women-Owned Small Business (EDWOSB) ")]), _c('option', {
    attrs: {
      "value": "LB"
    }
  }, [_vm._v("Large Business")]), _c('option', {
    attrs: {
      "value": "AI"
    }
  }, [_vm._v("Academic Institution")]), _c('option', {
    attrs: {
      "value": "NP"
    }
  }, [_vm._v("Non-Profit")])]), _vm.hasError('organizationType') ? _c('div', {
    staticClass: "invalid-feedback"
  }, [!_vm.$v.formData.organizationType.required ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" Please provide your organization type(s) ")]) : _vm._e()]) : _vm._e(), !_vm.hasError('organizationType') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" Please note that you may choose more than one organization type. ")]) : _vm._e()])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "codeCAGE"
    }
  }, [_vm._v("CAGE Code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.codeCAGE,
      expression: "formData.codeCAGE"
    }],
    staticClass: "form-control",
    class: _vm.hasError('codeCAGE') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "CAGE code"
    },
    domProps: {
      "value": _vm.formData.codeCAGE
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "codeCAGE", $event.target.value);
      }
    }
  }), !_vm.hasError('codeCAGE') ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" 5 character alpha-numeric identifier ")]) : _vm._e()])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "codesNAICS"
    }
  }, [_vm._v("NAICS Codes")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.codesNAICS,
      expression: "formData.codesNAICS"
    }],
    staticClass: "form-control",
    class: _vm.hasError('codesNAICS') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "NAICS codes (511120,...)"
    },
    domProps: {
      "value": _vm.formData.codesNAICS
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "codesNAICS", $event.target.value);
      }
    }
  }), !_vm.hasError('codesNAICS') ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" Numerics separated by space or comma. ")]) : _vm._e()])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numberOfEmployees"
    }
  }, [_vm._v("Number of Employees")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.numberOfEmployees,
      expression: "formData.numberOfEmployees"
    }],
    staticClass: "form-control",
    class: _vm.hasError('numberOfEmployees') ? 'is-invalid' : '',
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.formData, "numberOfEmployees", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Number of Employees")]), _c('option', {
    attrs: {
      "value": "1-10"
    }
  }, [_vm._v("1-10")]), _c('option', {
    attrs: {
      "value": "11-50"
    }
  }, [_vm._v("11-50")]), _c('option', {
    attrs: {
      "value": "51-500"
    }
  }, [_vm._v("51-500")]), _c('option', {
    attrs: {
      "value": " 501-2,000"
    }
  }, [_vm._v("501-2,000")]), _c('option', {
    attrs: {
      "value": "2,001-10,000"
    }
  }, [_vm._v("2,001-10,000")]), _c('option', {
    attrs: {
      "value": ">10,001"
    }
  }, [_vm._v(">10,001")])])])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "annualRevenue"
    }
  }, [_vm._v("Annual Revenues")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.annualRevenue,
      expression: "formData.annualRevenue"
    }],
    staticClass: "form-control",
    class: _vm.hasError('annualRevenue') ? 'is-invalid' : '',
    attrs: {
      "id": "annualRevenue"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.formData, "annualRevenue", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Annual Revenue")]), _c('option', {
    attrs: {
      "value": "<$200K"
    }
  }, [_vm._v("<$200K")]), _c('option', {
    attrs: {
      "value": "$200K-$1M"
    }
  }, [_vm._v("$200K-$1M")]), _c('option', {
    attrs: {
      "value": "$1M-$10M"
    }
  }, [_vm._v("$1M-$10M")]), _c('option', {
    attrs: {
      "value": "$10M-$50M"
    }
  }, [_vm._v("$10M-$50M")])])])]) : _vm._e(), _vm.isOrgAdmin ? _c('b-col', {
    staticClass: "py-1",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numberDUNS"
    }
  }, [_vm._v("DUNS Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.numberDUNS,
      expression: "formData.numberDUNS"
    }],
    staticClass: "form-control",
    class: _vm.hasError('numberDUNS') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "placeholder": "DUNS Number"
    },
    domProps: {
      "value": _vm.formData.numberDUNS
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "numberDUNS", $event.target.value);
      }
    }
  }), !_vm.hasError('numberDUNS') ? _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v(" 9 character numeric identifier ")]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "col-12 col-md-7 col-lg-7 col-xl-7",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('LlaAgreementWidget', {
    attrs: {
      "username": _vm.formData.forumScreenName,
      "llaStatus": _vm.formData.iagreeStatus,
      "llaAgreementStatusHandler": _vm.onLLAgreementSelectionHandler
    }
  })], 1)], 1)], 1)], 2)], 1)])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "contact-address pb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Sign up for a free Project Spectrum account")])]), _c('div', {
    staticClass: "address mt-2"
  }, [_c('p', [_vm._v(" Project Spectrum provides companies, institutions, and organizations with a comprehensive, cost-effective platform of cybersecurity information, resources, tools, and training. Our mission is to improve cybersecurity readiness, resiliency, and compliance of small/medium-sized businesses and the Defense Industrial Base (DIB) manufacturing supply chain. ")])])]);

}]

export { render, staticRenderFns }